import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Mount inside <BrowserRouter> to auto-fire a `page_view` event on every route change.
 * Excludes /admin/* paths so we don't pollute stats with admin activity.
 */
const AnalyticsListener = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

export default AnalyticsListener;
